import React from "react";
import ButtonCore from "../ButtonCore";
import { IButtonUIInterface } from "../interface";

const SecondaryButton: React.FC<React.PropsWithChildren<IButtonUIInterface>> = (props) => {
  return <ButtonCore type="secondary" {...props} />;
};

export default SecondaryButton;
